// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getUserProfileMain = createAsyncThunk(
	"user-profile/main/getUserProfileMain",
	createApiCall(async ({ login, isAuth = true }, client) => {
		const response = await client.get(
			isAuth
				? `/user/profile?login=${login}`
				: `/user/profile/unauthorized?login=${login}`
		);

		return {
			...response.data,
			counters: response.counters,
		};
	})
);

// ############################################################
